var _path;
import * as React from "react";
function SvgHighball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 2,0 H 22 L 19,24 H 5 Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighball);
export default __webpack_public_path__ + "static/media/Highball.f64a509d75c8bf44805fb923a735f6e6.svg";
export { ForwardRef as ReactComponent };